import { getProducts } from '@/services/product/get-products'
import { ProductsRequest, ProductsResponse } from '@/types/product'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'

export default function useGetProducts(params: ProductsRequest, queryOptions?: UseQueryOptions) {
  const query = useQuery({
    queryKey: ['get-products', { ...params } as never],
    queryFn: () => getProducts({ ...params }),
    refetchOnWindowFocus: false, // Không refetch khi focus window
    refetchOnMount: false, // Không refetch khi component mount nếu có cache
    ...queryOptions,
  })
  return {
    data: (query?.data as unknown as { data: ProductsResponse })?.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
    query,
  }
}
